export const getDataForBreadCrumbsFromUrl = (url: string) => url.split('/').filter((alias) => alias);
